// extracted by mini-css-extract-plugin
export var active = "_eq-7";
export var container = "_eq-0";
export var evenWidth = "_eq-4";
export var large = "_eq-5";
export var outlet = "_eq-8";
export var slide = "_eq-2";
export var small = "_eq-6";
export var tab = "_eq-3";
export var tabs = "_eq-1";